require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-microsoft-inspire-2019-a-week-on-has-it-kept-its-fizz.json") })
        }
      }, "path---blog-microsoft-inspire-2019-a-week-on-has-it-kept-its-fizz");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-microsoft-inspire-2019-a-week-on-has-it-kept-its-fizz!./.cache/json/blog-microsoft-inspire-2019-a-week-on-has-it-kept-its-fizz.json
// module id = 833
// module chunks = 231608221292675